// extracted by mini-css-extract-plugin
module.exports = {"upgradeWidgetContainer":"UpgradeWidget_upgradeWidgetContainer__Go_pz","upgradeWidget":"UpgradeWidget_upgradeWidget__PZWwU"};